import { Component, Inject, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
} from '@angular/material/dialog';
import { ButtonStyle } from '@constants/button/1.0';
import { MessageType } from '@constants/message/1.0';
import { ConfirmationDialogData } from '../confirmation/1.0/index';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgIf } from '@angular/common';
import { MessageComponent } from '../message/1.0/message.component';
import { MatFormField, MatLabel, MatSuffix, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { ButtonComponent } from '../button/1.0/button.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'txp-delete-key-dialog',
  templateUrl: './delete-key-dialog.component.html',
  styleUrls: ['./delete-key-dialog.component.scss'],
  standalone: true,
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    NgIf,
    MessageComponent,
    MatFormField,
    MatLabel,
    MatInput,
    MatSuffix,
    MatError,
    MatDialogActions,
    ButtonComponent,
    TranslateModule,
  ],
})
export class DeleteKeyDialogComponent implements OnInit {
  form: UntypedFormGroup;

  buttonStyle = ButtonStyle;
  disableContinueBtn = true;
  isSaving: boolean;
  showError: boolean;
  messageType = MessageType;
  errorMessage: string;

  constructor(
    private dialogRef: MatDialogRef<DeleteKeyDialogComponent>,
    private formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogData,
  ) {
    this.form = this.formBuilder.group({
      password: new UntypedFormControl('', Validators.required),
    });
    dialogRef.disableClose = true;
  }

  onAction(value: boolean) {
    if (value) {
      this.isSaving = true;
      this.showError = false;
      this.dialogRef.close(value);
    } else {
      return this.dialogRef.close(value);
    }
  }

  ngOnInit(): void {
    this.form?.get('password')?.valueChanges.subscribe((value) => {
      this.disableContinueBtn = !(value === this.data.inputConfirmText);
    });
  }
}
